import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { CreateController } from '@/types/controller'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'

async function createController(payload: CreateController): Promise<void> {
  await controllerDataConfigApi.create(payload)
}
function useAddController() {
  const queryClient = useQueryClient()

  return useMutation((payload: CreateController) => createController(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.controller])
      queryClient.invalidateQueries([queryKeys.stations])
    },
    onError: (error: AxiosError<any>) => {
      toast.error(error?.response?.data?.Message)
    },
  })
}

export default useAddController
